import styled from "styled-components";
import { useEffect, useRef, useState } from "react";

import * as css from "styles/CssVariables.js";
import { COUNTRY_ICONS } from "constants/countries";
import Dropdown from "components/forms/Dropdown";
import SelectionItem from "components/forms/SelectionItem";
import DropdownSelection from "components/forms/DropdownSelection";

import circleGreyIcon from "assets/img/icons/icons8-circle-grey.svg";

const DropdownWrap = styled.div`
  position: relative;
  width: 100%;
  max-width: 290px;

  display: flex;
  flex-direction: column;
  gap: ${css.VERTICAL_BOX_MARGIN};
`;

const CountrySelectionItem = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

const SelectionIcon = styled.div`
  width: 26px;
  min-width: 26px;
  height: 26px;
  max-height: 26px;
`;

const SelectionText = styled.div`
  font-family: "Arial", sans-serif;
`;

export default ({
  selectedCountry,
  placeholder,
  onCountrySelect,
  warning,
  position = "bottom",
}) => {
  const dropdownRef = useRef();
  const selectionRef = useRef();

  const [selectionOpened, setSelectionOpened] = useState(false);

  function useSelectionOutsideClick(ref) {
    useEffect(() => {
      function handleClickOutside(event) {
        if (
          ref.current &&
          !ref.current.contains(event.target) &&
          !dropdownRef.current.contains(event.target)
        ) {
          toggleSelection();
        }
      }

      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }, [ref]);
  }

  useSelectionOutsideClick(selectionRef);

  const toggleSelection = (close) => {
    setSelectionOpened((prevState) => !prevState);
  };

  const countryOptions = COUNTRY_ICONS;

  let optionsList = [];

  Object.keys(countryOptions).forEach((country) => {
    optionsList.push(
      <SelectionItem
        onClick={() => {
          onCountrySelect(country);
          toggleSelection();
        }}
        key={country}
      >
        <CountrySelectionItem>
          <SelectionIcon>
            <img
              src={countryOptions[country].icon}
              alt={country}
              style={{ width: "100%", maxHeight: "100%" }}
            />
          </SelectionIcon>
          <SelectionText>{country}</SelectionText>
        </CountrySelectionItem>
      </SelectionItem>
    );
  });

  return (
    <DropdownWrap>
      <Dropdown
        onClick={toggleSelection}
        dropdownRef={dropdownRef}
        warning={warning}
      >
        {!selectedCountry && placeholder}
        {selectedCountry && (
          <CountrySelectionItem>
            <SelectionIcon>
              <img
                src={
                  countryOptions[selectedCountry]
                    ? countryOptions[selectedCountry].icon
                    : circleGreyIcon
                }
                alt={selectedCountry}
                style={{ width: "100%", maxHeight: "100%" }}
              />
            </SelectionIcon>
            <SelectionText>{selectedCountry}</SelectionText>
          </CountrySelectionItem>
        )}
      </Dropdown>
      {selectionOpened && (
        <DropdownSelection
          width="290px"
          selectionRef={selectionRef}
          top={position === "top" ? "-306px" : "48px"}
        >
          {optionsList}
        </DropdownSelection>
      )}
    </DropdownWrap>
  );
};
